import * as React from "react";
import { AbstractReactFactory } from "@projectstorm/react-canvas-core";
import ComponentNodeModel from "./ComponentNodeModel";
import ComponentNodeWidget from "./ComponentNodeWidget";

export default class ComponentNodeFactory extends AbstractReactFactory {
  constructor() {
    super("component");
  }

  generateModel(data) {
    return new ComponentNodeModel({ engine: this.engine, data });
  }

  generateReactWidget(event) {
    return <ComponentNodeWidget engine={this.engine} node={event.model} />;
  }
}
